<template >
  <div class="bgHeader">
    <div class="container">
      <img src="@/assets/banner.png" alt="" />
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    
  },
  name: "BusinessHelp",
  data() {
    return {

    }
  },
  methods: {

  },
};
</script>

<style>
</style>
